import { Container, SimpleGrid } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { ContentCard } from '../../common';

const InsuranceMeasurements: React.FC = () => (
  <Container maxW="1200px" px={500} mb={{ base: '72px', desktop: '152px' }}>
    <SimpleGrid
      columns={{ base: 1, desktop: 2 }}
      alignItems="center"
      spacing={{ base: 700, desktop: 1100 }}
    >
      <ContentCard
        maxW="xl"
        title="MEASUREMENTS"
        header="Settle More Claims With Remote Measurements"
        topBody="Super accurate and complete roof and elevation data for any property from just eight smartphone photos."
        bottomBody="Invite policyholders to photograph their home to expedite claims.
        Spend less time on-site and resolve more claims per day."
      />
      <Container px={0} centerContent>
        <StaticImage
          quality={100}
          placeholder="blurred"
          alt="marketing"
          src="../../../assets/images/insurance_measurements.png"
        />
      </Container>
    </SimpleGrid>
  </Container>
);

export default InsuranceMeasurements;
